export default {};

export const timeKeyToTitle = {
  regularTime: 'Regular',
  breakTime: 'Break',
  overtime: 'Overtime',
  doubleOT: 'Double OT',
  pto: 'PTO',
};

export const timeKeyToDBKey = {
  regularTime: '',
  breakTime: 'break',
  overtime: 'ot',
  doubleOT: 'doubleOT',
  pto: 'pto',
};

export const ALWAYS_SHOW_KEYS = ['regularTime', 'breakTime', 'overtime'];
export const ALL_KEYS = [...ALWAYS_SHOW_KEYS, 'doubleOT'];
